import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { KeretService } from '../../keret.service';
import { modeNev, modeFavicon } from '../../mode-nevek';
import { SzamlazoAktiv, SzamlazoService } from '../szamlazo.service';

interface SzPont { ut: string; cim: string; ikon: string; leiras: string; }
interface SzFul { kulcs: string; cim: string; ikon: string; ut?: string; pontok?: SzPont[]; }

/*  SZÁMLÁZÓ – a modul kerete. Fókusz témában a NAPLO/BÉR/Tárgyi eszköz fejlécének párja (sötét sáv a
 *  modul ikonjával, fülek, jobbra a cég + év és a profil), Klasszikusban egyszerű eszköztár (a menüt a
 *  bal sáv adja). A modul színe rózsapiros; a modálok a `body.szamlazo-aktiv` osztályról kapják.
 *
 *  A cégválasztó a látható cégeket kínálja SZEREPPEL: ügyfélként (a saját cég – ír) vagy könyvelőként
 *  (csak olvas). Könyvelői nézetben egy sáv jelzi, hogy itt nincs szerkesztés. */
@Component({
  selector: 'app-szamlazo-layout',
  templateUrl: './szamlazo-layout.component.html',
  styleUrls: ['./szamlazo-layout.component.scss'],
})
export class SzamlazoLayoutComponent implements OnInit, OnDestroy {
  alrendszerNev = modeNev('SZAMLAZO');
  modIkon = modeFavicon('SZAMLAZO');
  aktiv: SzamlazoAktiv = { intezmeny: '', ugyfelId: null, ugyfelNev: null, szerep: null, ev: new Date().getFullYear() };
  /*  A FELSŐ MENÜSOR CSOPORTOKBAN. Tíz külön fül nem fért ki a sávba (túllógott az oldalon), ezért a
   *  rokon oldalak egy-egy lenyíló csoportba kerültek – kattintásra a fejléc alatt csempék nyílnak
   *  (a NAPLO fejlécének mintájára). A Kezdőlap közvetlenül nyit; a törzsadatok és a beállítások a Szervíz alatt. */
  readonly fulek: SzFul[] = [
    { kulcs: 'kezdolap', cim: 'Kezdőlap', ikon: 'home-outline', ut: '/szamlazo/kezdolap' },
    { kulcs: 'szamlazas', cim: 'Számlázás', ikon: 'receipt-outline', pontok: [
      { ut: '/szamlazo/szamlak', cim: 'Számlák', ikon: 'receipt-outline', leiras: 'Kiállítás, sztornó, NAV-beküldés' },
      { ut: '/szamlazo/dijbekerok', cim: 'Díjbekérők', ikon: 'document-text-outline', leiras: 'Előlegbekérő, fizetés után számla' },
      { ut: '/szamlazo/kintlevosegek', cim: 'Kintlévőségek', ikon: 'time-outline', leiras: 'Rendezetlen tételek, kiegyenlítések' },
    ] },
    { kulcs: 'ertekesites', cim: 'Ajánlat, rendelés', ikon: 'cube-outline', pontok: [
      { ut: '/szamlazo/arajanlatok', cim: 'Árajánlatok', ikon: 'pricetag-outline', leiras: 'Ajánlat, belőle rendelés vagy számla' },
      { ut: '/szamlazo/megrendelesek', cim: 'Megrendelések', ikon: 'cart-outline', leiras: 'Vevői rendelések' },
      { ut: '/szamlazo/szallitolevelek', cim: 'Szállítólevelek', ikon: 'cube-outline', leiras: 'Kiszállítás, gyári számok' },
    ] },
    { kulcs: 'kassza', cim: 'Kassza', ikon: 'cart-outline', pontok: [
      { ut: '/szamlazo/kassza', cim: 'Bolti eladás', ikon: 'cart-outline', leiras: 'Pénztár vonalkód-olvasóval, nyugta' },
      { ut: '/szamlazo/nyugtak', cim: 'Nyugták', ikon: 'receipt', leiras: 'Kiadott nyugták, NAV-adatszolgáltatás' },
    ] },
    { kulcs: 'szerviz', cim: 'Szervíz', ikon: 'construct-outline', pontok: [
      { ut: '/szamlazo/ugyfelek', cim: 'Ügyfelek (cégek)', ikon: 'business-outline', leiras: 'Cégválasztó, önálló módban saját ügyfélkör' },
      { ut: '/ugyfelportal', cim: 'Könyvelésem', ikon: 'library-outline', leiras: 'A cég könyvelése, bevallásai, bére – olvasásra' },
      { ut: '/szamlazo/vevok', cim: 'Vevők', ikon: 'people-outline', leiras: 'Partnertörzs' },
      { ut: '/szamlazo/termekek', cim: 'Cikktörzs', ikon: 'pricetags-outline', leiras: 'Termékek, szolgáltatások, árak' },
      { ut: '/szamlazo/beallitasok', cim: 'Beállítások', ikon: 'settings-outline', leiras: 'Cégadatok, tömbök, NAV, hozzáférés' },
    ] },
  ];
  nyitottMenu: string | null = null;
  aktivUt = '';
  evek: number[] = [];

  valasztoNyitva = false;
  ugyfelek: any[] = [];
  kereso = '';

  private sub?: Subscription;
  private navSub?: Subscription;
  constructor(public router: Router, private keret: KeretService, private sz: SzamlazoService) {}

  get fokusz(): boolean { return this.keret.a?.tema() === 'fokusz'; }

  async ngOnInit() {
    await this.sz.init();
    this.sub = this.sz.aktiv$.subscribe((a) => (this.aktiv = a));
    await this.sz.kozosAtvesz();
    const most = new Date().getFullYear();
    this.evek = [most + 1, most, most - 1, most - 2, most - 3];
    this.utFrissit();
    this.navSub = this.router.events.pipe(filter((e) => e instanceof NavigationEnd)).subscribe(() => this.utFrissit());
    document.body.classList.add('szamlazo-aktiv');
    if (!this.aktiv.ugyfelId) this.valasztoNyit();
  }
  ngOnDestroy() { this.sub?.unsubscribe(); this.navSub?.unsubscribe(); document.body.classList.remove('szamlazo-aktiv'); }
  private utFrissit() { this.aktivUt = this.router.url.split('?')[0]; this.nyitottMenu = null; }

  /** Aktív-e a fül: a saját útja vagy valamelyik csoportpontja van megnyitva. */
  fulAktiv(f: SzFul): boolean { return f.ut ? this.aktivUt === f.ut : !!f.pontok?.some((p) => this.aktivUt === p.ut); }
  get lenyiloPontok(): SzPont[] { return this.fulek.find((f) => f.kulcs === this.nyitottMenu)?.pontok || []; }
  fulKattint(f: SzFul, ev: Event) {
    ev.stopPropagation();
    if (f.ut) { this.nyitottMenu = null; this.open(f.ut); return; }
    this.nyitottMenu = this.nyitottMenu === f.kulcs ? null : f.kulcs;
  }
  pontNyit(p: SzPont) { this.nyitottMenu = null; this.open(p.ut); }
  @HostListener('window:keydown.escape') escape() { this.nyitottMenu = null; }

  /*  Az ügyfélválasztó saját oldal (components/modul-ugyfelek): csempe / lista, keresés, önálló
   *  módban új ügyfél is – a modul ügyfélkör-módja szerint (backend/ugyfeltorzs.js). */
  valasztoNyit() { if (!this.router.url.startsWith('/szamlazo/ugyfelek')) this.router.navigateByUrl('/szamlazo/ugyfelek'); }

  get lathatoUgyfelek(): any[] {
    const k = this.kereso.trim().toLowerCase();
    return k ? this.ugyfelek.filter((u) => String(u.nev || '').toLowerCase().includes(k) || String(u.adoszam || '').includes(k)) : this.ugyfelek;
  }
  async ugyfelValaszt(u: any) {
    this.valasztoNyitva = false;
    await this.sz.setAktiv({ ugyfelId: u.id, ugyfelNev: u.nev, szerep: u.szerep });
  }
  async evValt(ev: number) { await this.sz.setAktiv({ ev: Number(ev) }); }
  open(url: string) { this.router.navigateByUrl(url); }
}
